<template>
  <div>
    <!--创建付款申请第一步-->
    <el-dialog
      :visible.sync="step1Visible"
      class="new-bill-payment-dialog"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="1150px"
      :title="title"
      top="5vh"
    >
      <div>
        <native-query-charge-for-pay-apply
          v-if="!isQueryJob"
          ref="queryCharge"
          :show-simple="false"
          identify="queryCharge"
          view-source="billPaymentByJob_Create_Charge"
          :has-bill-payment="0"
          charge-state-param="BillPaymentChargeState"
          confirm-state-param="BillPaymentChargeConfirmState"
          job-state-param="BillPaymentJobState"
          :is-ar="defaultSearchConditions.isAr"
          :show-charge-count="showWindow"
          :check-verified-amount="true"
          :show-controlled-charge="false"
          :is-show-write-off="false"
          :new-by-job="2"
          :internal-charge="defaultSearchConditions.internalCharge"
          config-module="5804"
          grid-config-module="580401"
        >
          <template v-slot:searchAreaHeader>
            <div class="app-main-inner-row  extension-conditions-form">
              <div class="filters">
                <div style="display:flex">
                  <span style="margin: 7px;">{{ $t('Payment.inquiryWay') }}</span>
                  <template>
                    <el-form inline>
                      <el-form-item>
                        <el-radio-group v-model="queryType" @change="onQueryTypeChange">
                          <el-radio label="charge">{{ $t('Payment.accordingToCharge') }}</el-radio>
                          <el-radio label="job">{{ $t('Payment.accordingToBusiness') }}</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item>
                        <el-checkbox v-model="defaultSearchConditions.isAr" :true-label="-1" :false-label="0">{{ $t('Payment.includeReceivables') }}</el-checkbox>
                      </el-form-item>
                      <el-form-item v-show="useOrderCenterMode">
                        <el-checkbox v-model="defaultSearchConditions.internalCharge">{{ $t('CargoMsg.Cargo_InternalCharges') }}</el-checkbox>
                      </el-form-item>
                    </el-form>
                  </template>
                  <span style="color: #ff0000;margin: 7px;">{{ $t('Payment.couldNotSearhWriteOffJobFromThisWindow') }}</span>
                </div>
              </div>
            </div>
          </template>
        </native-query-charge-for-pay-apply>
        <query-job-fast-for-pay-apply
          v-if="isQueryJob"
          ref="queryJob"
          :show-simple="false"
          identify="queryJob"
          view-source="billPayment_Create_Job"
          total-data-field="chargeAmount"
          total-currency-field="chargeCurrency"
          charge-state-param="BillPaymentChargeState"
          confirm-state-param="BillPaymentChargeConfirmState"
          job-state-param="BillPaymentJobState"
          :is-ar="defaultSearchConditions.isAr"
          :has-bill-payment="0"
          :show-charge-count="showWindow"
          :show-controlled-charge="false"
          :new-by-job="1"
          :is-show-write-off="false"
          :internal-charge="defaultSearchConditions.internalCharge"
          config-module="5083"
          grid-config-module="50830101"
        >
          <template v-slot:searchAreaHeader>
            <div class="app-main-inner-row  extension-conditions-form">
              <div class="filters">
                <div style="display:flex">
                  <span style="margin: 7px;">{{ $t('Payment.inquiryWay') }}</span>
                  <template>
                    <el-form inline>
                      <el-form-item>
                        <el-radio-group v-model="queryType" @change="onQueryTypeChange">
                          <el-radio label="charge">{{ $t('Payment.accordingToCharge') }}</el-radio>
                          <el-radio label="job">{{ $t('Payment.accordingToBusiness') }}</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item>
                        <el-checkbox v-model="defaultSearchConditions.isAr" :true-label="-1" :false-label="0">{{ $t('Payment.includeReceivables') }}</el-checkbox>
                      </el-form-item>
                      <el-form-item v-show="useOrderCenterMode">
                        <el-checkbox v-model="defaultSearchConditions.internalCharge">{{ $t('CargoMsg.Cargo_InternalCharges') }}</el-checkbox>
                      </el-form-item>
                    </el-form>
                  </template>
                  <span style="color: #ff0000; margin: 7px;">{{ $t('Payment.couldNotSearhWriteOffJobFromThisWindow') }}</span>
                </div>
              </div>
            </div>
          </template>
        </query-job-fast-for-pay-apply>
      </div>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          @click="nextStep"
        >{{ $t('Payment.next') }}</el-button>
        <el-button
          size="mini"
          @click="cancel"
        >{{ $t('Payment.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!--创建付款申请第二步-->
    <bill-payment-dialog
      ref="billPayment"
      :visible.sync="step2Visible"
      :title="billPaymentDialog.title"
      :open-sap-config="openSapConfig"
      :location="location"
      :view-source="'billPayment_Create_Job'"
      @toPreStep="toPreStep"
      @cancel="cancel"
      @reloadData="reloadData"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'

import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import { queryChargeList } from '@/api/clearing/billingNative'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import nativeQueryChargeForPayApply from '@/views/cargo/v0/Clearing/components/nativeQuery/nativeQueryChargeForPayApply'
import queryJobFastForPayApply from '@/views/cargo/v0/Clearing/components/query/queryJobFastForPayApply'
import { cacheName, cache } from '@/utils/cacheManager'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import billPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPaymentByJob/billPaymentDialog'

export default {
  name: 'BillPaymentCreatorDialog',
  components: { searchItem, nativeQueryChargeForPayApply, queryJobFastForPayApply, billPaymentDialog },
  props: {
    location: { type: String, required: false }
  },
  data() {
    return {
      openSapConfig: false,
      step: '',
      queryType: 'charge', //
      innerVisible: this.visible,
      showWindow: false, // 是否显示右下弹框
      title: '',
      defaultSearchConditions: {
        isAr: 0, // 应收/应付
        advance: -1, //  是否垫付
        oversea: -1, // （国内/国外）
        hasInvoice: -1, // 是否开票
        hasDiffCharge: -1, // 是否关联差异对冲费用
        jobStates: [], // 业务状态
        chargeStates: [], // 费用状态
        confirmStates: [], // 费用确认状态
        exceptKeys: [], // 在查询中想要例外的对象列表
        hasBillPayment: -1, // 是否关联付款申请
        hasBilling: -1, // 是否关联账单
        paidOff: -1, // 是包含以核销
        internalCharge: false // 内结
      },
      billPaymentDialog: { // 付款申请弹窗
        title: ''
      }
    }
  },
  computed: {
    isQueryJob() {
      return this.queryType === 'job'
    },
    step1Visible() {
      return this.step === 'step1'
    },
    step2Visible() {
      return this.step === 'step2'
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return RateUtil.useOrderCenterMode()
    }
  },
  watch: {
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.openSapConfig = Number(cache.config.get('openSapConfig')) === 1
    this.showWindow = Number(cache.config.get('showChargeWindow')) === 1
    if (this.params && this.params.hasOwnProperty('title')) {
      this.title = this.params.title
    }
  },
  methods: {
    createBillPayment(parameter) {
      if (parameter && parameter.hasOwnProperty('step')) {
        this.step = parameter['step']
      }
      if (parameter && parameter.hasOwnProperty('title')) {
        this.title = parameter['title']
      }
    },
    onQueryTypeChange(val) {
      this.queryType = val
    },
    // 下一步按钮触发事件
    nextStep() {
      // 装费用详情页数据
      let chooseRows = []
      if (!this.isQueryJob) { // 按费用校验
        chooseRows = this.$refs.queryCharge.getSelections()
        if (!chooseRows || chooseRows.length === 0) {
          this.$message.warning(this.$t('Message.PleaseSelectCharges'))
          return
        }
        // 验证结算对象全部相同
        if (!this.isSameAccount(chooseRows)) {
          this.$message.warning(this.$t('Message.SettleAccountMustBeSame'))
          return
        }
        // 验证应收费用不能大于应付费用
        if (!this.checkBillPaymentCharge(chooseRows)) {
          this.$message.warning(this.$t('Message.ReceivableCannotMorethanPay'))
          return
        }
        this.billPaymentDialog.title = this.$t('CargoMsg.Cargo_CreatePaymentRequestDetails')
        this.step = 'step2'
        this.$refs.billPayment.initBillPayment(chooseRows)
      } else { // 按业务校验
        chooseRows = this.$refs.queryJob.getSelections()
        if (!chooseRows || chooseRows.length === 0) {
          this.$message.warning(this.$t('Message.PleaseSelectJobs'))
          return
        }
        // 验证结算对象全部相同
        if (!this.isSameAccount(chooseRows)) {
          this.$message.warning(this.$t('Message.SettleAccountMustBeSame'))
          return
        } else {
          this.loadJobCharges(this.$refs.queryJob.getConditions(), chooseRows)
        }
      }
    },
    // 根据job查询符合付款申请的费用
    loadJobCharges(conditions, rows) {
      const jobKeys = []
      for (const job of rows) {
        if (job.uuid && jobKeys.indexOf(job.uuid) < 0) {
          jobKeys.push(job.uuid)
        }
      }
      // 组装高级查询调价
      conditions.push(new AdvancedSearchOption(null, 'job.UUID', jobKeys, OperatorConstants.OPERATOR_IN.code).formatObj2Json())
      if (!LoadDefaultQueryParam.isSelectOption(conditions, 'charge.ACCOUNT_ID')) {
        const option = new AdvancedSearchOption(null, 'charge.ACCOUNT_ID', rows[0].chargeAccountId, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(option.formatObj2Json())
      }
      if (!LoadDefaultQueryParam.isSelectOption(conditions, 'charge.CURRENCY')) {
        const currencyArray = this.getCurrencyArray(rows)
        const option = new AdvancedSearchOption(null, 'charge.CURRENCY', currencyArray, OperatorConstants.OPERATOR_IN.code)
        conditions.push(option.formatObj2Json())
      }
      const requestBody = { paging: false, conditions, branchId: this.$store.getters.currentOfficeId, requestSource: 'billPayment_Create_Charge' }
      queryChargeList(requestBody).then((res) => {
        const charges = res.data.list
        if (charges && charges.length > 0) {
          // 验证结算对象全部相同
          if (!this.isSameAccount(charges)) {
            this.$message.warning(this.$t('Message.SettleAccountMustBeSame'))
            return
          }
          // 验证应收费用不能大于应付费用
          if (!this.checkBillPaymentCharge(charges)) {
            this.$message.warning(this.$t('Message.ReceivableCannotMorethanPay'))
            return
          }
          this.billPaymentDialog.title = this.$t('CargoMsg.Cargo_CreatePaymentRequestDetails')
          this.step = 'step2'
          this.$refs.billPayment.initBillPayment(res.data.list)
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_PRCTBCFWOE'))
          return
        }
      }).finally()
    },
    // 判断费用结算对象是否相同
    isSameAccount(rows) {
      const chargeAccount = rows[0].chargeAccountId
      for (let i = 1; i < rows.length; i++) {
        if (chargeAccount !== rows[i].chargeAccountId) {
          return false
        }
      }
      return true
    },
    // 校验整个付款申请的金额必须是应付
    checkBillPaymentCharge(rows) {
      let c1 = 0
      let c2 = 0
      for (const charge of rows) {
        const businessDate = !charge.chargeInputDate ? charge.chargeDateCreated : charge.chargeInputDate
        const localCurrency = RateUtil.localCurrencyByOfficeId(charge.chargeBranchId)
        if (charge.chargeReceivable) {
          c1 += charge.chargeAmount * RateUtil.getForeignExchangeRateSafely(localCurrency, charge.chargeCurrency, businessDate, charge.chargeBranchId)
        } else {
          c2 += charge.chargeAmount * RateUtil.getForeignExchangeRateSafely(localCurrency, charge.chargeCurrency, businessDate, charge.chargeBranchId)
        }
      }
      return c1 === 0 || c2 - c1 >= 0
    },
    // 组装业务费用所有币种
    getCurrencyArray(jobs) {
      const currencyArray = []
      for (const job of jobs) {
        if (currencyArray.indexOf(job.chargeCurrency) < 0) {
          currencyArray.push(job.chargeCurrency)
        }
      }
      return currencyArray
    },
    toPreStep(data) { // 上一步
      this.step = data
    },
    cancel() {
      this.step = ''
      if (this.isQueryJob) {
        this.$refs.queryJob.reSetProperties()
      } else {
        this.$refs.queryCharge.reSetProperties()
      }
    },
    reloadData(data) {
      this.$emit('reloadData', data)
      this.$refs.billPayment.curBillPaymentUuid = data.uuid
    }
  }
}
</script>
<style lang="scss">
.new-bill-payment-dialog {
  .el-radio {
    margin-right: 0;
    margin-left: 10px;
  }
}
</style>
